import { Mail, Phone, Clock, MapPin } from "lucide-react";
import { siteConfig } from "../data/siteConfig";
import { ContactForm } from "./ContactForm";

export function ContactSection() {
  const cleanPhone = siteConfig.contactPhone.replace(/\D/g, "");

  return (
    <section className="contact-section" id="contact">
      <div className="site-shell contact-section__grid">
        <div className="reveal">
          <p className="kicker">Get in touch</p>
          <h2>Ready to file, or have questions before starting?</h2>
          <p className="contact-section__lede">
            Reach out directly to Gaurab Subedi. Whether you want to verify your tax situation, ask
            about supported forms, or need help with intake, we provide prompt, transparent support.
          </p>

          <div className="contact-info-list">
            <a className="contact-info-card" href={`mailto:${siteConfig.contactEmail}`}>
              <div className="contact-info-card__icon">
                <Mail size={20} aria-hidden="true" />
              </div>
              <div className="contact-info-card__content">
                <span className="contact-info-card__label">Email directly</span>
                <span className="contact-info-card__value">{siteConfig.contactEmail}</span>
              </div>
            </a>

            <a className="contact-info-card" href={`tel:${cleanPhone}`}>
              <div className="contact-info-card__icon">
                <Phone size={20} aria-hidden="true" />
              </div>
              <div className="contact-info-card__content">
                <span className="contact-info-card__label">Call or text</span>
                <span className="contact-info-card__value">{siteConfig.contactPhone}</span>
              </div>
            </a>

            <div className="contact-info-card">
              <div className="contact-info-card__icon">
                <Clock size={20} aria-hidden="true" />
              </div>
              <div className="contact-info-card__content">
                <span className="contact-info-card__label">Business hours</span>
                <span className="contact-info-card__value">{siteConfig.businessHours}</span>
              </div>
            </div>

            <div className="contact-info-card">
              <div className="contact-info-card__icon">
                <MapPin size={20} aria-hidden="true" />
              </div>
              <div className="contact-info-card__content">
                <span className="contact-info-card__label">Location &amp; jurisdiction</span>
                <span className="contact-info-card__value">{siteConfig.location}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-section__form-wrap reveal reveal--delay">
          <ContactForm />
        </div>
      </div>
    </section>
  );
}
